import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { AddToCartSuccess } from '@app/core/cart/actions/cart.actions';

/**
 * When a product is added to cart.
 */
const events = getEvents((action: AddToCartSuccess) => {
  return [
    {
      type: 'event',
      container: TagContainer.Analytics,
      payload: {
        event: 'productAddToCart',
        addToCartType: 'product_page',
        order_currency: action.payload.product.price.currency,
        products: [
          {
            id: action.payload.product.id,
            name: action.payload.product.name,
            brand: action.payload.product.brand.name,
            price: action.payload.product.price.cents,
            price_eur: '',
            quantity: String(action.payload.quantity),
            category:
              (action.payload.product.universe ? action.payload.product.universe.name.toLocaleUpperCase() : '') +
              '_' +
              (action.payload.product.category ? action.payload.product.category.name.toLocaleLowerCase() : '')
          }
        ]
      }
    },
    {
      type: 'Add to cart popin',
      container: TagContainer.Media
    }
  ];
});

export default events;
